import * as React from 'react';
import { ClipLoader } from 'react-spinners';

export const TabContentOverlayLoader: React.FC<{ loadingMess: string }> = ({
  loadingMess,
}): JSX.Element => {
  return (
    <div
      style={{ backgroundColor: 'rgba(255, 255,255 , 0.8)' }}
      className="w-full h-screen z-10 absolute top-0 right-0 
      flex flex-col justify-center items-center"
    >
      <ClipLoader size={40} color="#333" />
      <p className="font-medium text-lg">{loadingMess}</p>
    </div>
  );
};
